import * as Actions from "../actions/agent-actions";

const initialState = {
	agentList: [],
	selectedAgent: null,
	isLoading: false,
	isFetchingAgent: false,
	isUpdating: false,
	error: null,
	configExpanded: true,

	agentData: {
		bio: {
			// Entities Table State
			entitiesSortType: "relevancy",
			entitiesSortAscending: false,
			entitiesCursorPosition: 1,
			entitiesPageLength: 20,
			entitiesPageOffset: 0,

			// Affiliations Graph
			graphData: {},
			graphEdgeMap: {},
			graphNodeMap: {},
			graphDataLoading: false,
			graphDataError: false,
			graphDataFetchCount: 0,
			graphDepth: "1",
			graphExpandDepth: "1",
			graphSettingsExpanded: true,
			graphFiltersExpanded: true,
			graphExpanding: false,
			graphExpandError: 0,
			graphExpandFetchCount: 0,
			graphNodesAdded: 0,
			graphEdgesAdded: 0,
			graphNodesRemoved: 0,
			graphEdgesRemoved: 0,
			graphNumUpdates: 0,
			graphLayoutRunning: false,
			showGraphLabels: true,
			showGraphEdgeLabels: true,
			exportOptions: {
				exportLayers: {
					nodes: { name: "nodes", label: "entities", enabled: true },
					edges: { name: "edges", label: "edges", enabled: true },
					labels: { name: "labels", label: "entity labels", enabled: true },
					edgeLabels: { name: "edgeLabels", label: "edge labels", enabled: true },
				},
				optimizeForPrint: true,
				exportFullGraph: true,
				forceLabels: false,
				compressLabels: false,
			},

			// Affiliations Graph Edge Relation Data
			entityRelationData: null,
			entityRelationDataLoading: false,
			entityRelationDataError: false,
			entityRelationDataFetchCount: 0,

			// Widget State
			entitiesExpanded: true,
			affiliationsExpanded: true,
		},
	},

	errorState: {
		throwError: null,
	},
};

const agentReducer = (state = initialState, action) => {
	switch (action.type) {
		case Actions.ADD_AGENT:
		case Actions.DELETE_AGENT:
		case Actions.FETCH_AGENTS_REQUEST:
			return {
				...state,
				isLoading: true,
				error: null,
			};

		case Actions.FETCH_AGENT_REQUEST:
			return {
				...state,
				isFetchingAgent: true,
				error: null,
			};

		case Actions.ADD_AGENT_SUCCESS:
			return {
				...state,
				isLoading: false,
				agentList: [...state.agentList, action.payload],
			};

		case Actions.UPDATE_AGENT_SUCCESS:
			return {
				...state,
				isLoading: false,
				agentList: state.agentList.map((agent) =>
					agent.id === action.payload.id ? { ...action.payload, isLoading: false } : agent
				),
			};

		case Actions.DELETE_AGENT_SUCCESS:
			return {
				...state,
				isLoading: false,
				agentList: state.agentList.filter((agent) => agent.id !== action.payload),
			};

		case Actions.SET_AGENT_STATUS:
			return {
				...state,
				agentList: state.agentList.map((agent) =>
					agent.id === action.payload.agentId ? { ...agent, status: action.payload.status } : agent
				),
			};

		case Actions.FETCH_AGENTS_SUCCESS: {
			const newAgentList = action.payload;
			const currentSelectedAgent = state.selectedAgent;
			const newSelectedAgent =
				currentSelectedAgent && newAgentList.find((x) => x.id === currentSelectedAgent.id)
					? currentSelectedAgent
					: newAgentList.length > 0
						? newAgentList[0]
						: null;

			return {
				...state,
				isLoading: false,
				agentList: newAgentList,
				selectedAgent: newSelectedAgent,
			};
		}

		case Actions.FETCH_AGENT_SUCCESS:
			return {
				...state,
				isFetchingAgent: false,
				selectedAgent: state.selectedAgent ? state.selectedAgent : action.payload,
			};

		case Actions.ADD_AGENT_FAILURE:
		case Actions.DELETE_AGENT_FAILURE:
		case Actions.FETCH_AGENTS_FAILURE:
		case Actions.FETCH_AGENT_FAILURE:
			return {
				...state,
				isLoading: false,
				isFetchingAgent: false,
				error: action.error,
			};

		case Actions.UPDATE_AGENT:
			return {
				...state,
				isLoading: true,
				isFetchingAgent: false,
				error: null,
				agentList: state.agentList.map((agent) =>
					agent.id === action.payload.id ? { ...agent, isLoading: true } : agent
				),
			};

		case Actions.UPDATE_AGENT_FAILURE:
			return {
				...state,
				isLoading: false,
				isFetchingAgent: false,
				agentList: state.agentList.map((agent) =>
					agent.id === action.payload.id ? { ...agent, isLoading: false } : agent
				),
				error: action.error,
			};

		case Actions.AGENT_SET_CONFIG_WIDGET_EXPANDED: {
			return {
				...state,
				configExpanded: action.expanded,
			};
		}

		case Actions.AGENT_SET_SELECTED_AGENT: {
			return {
				...state,
				selectedAgent: action.payload,
			};
		}

		//
		// BIO AGENT SPECIFIC
		//

		case Actions.AGENT_FETCH_ENTITY_RELATION_DATA: {
			return {
				...state,
				agentData: {
					...state.agentData,
					bio: {
						...state.agentData.bio,
						entityRelationData: null,
						entityRelationDataLoading: true,
						entityRelationDataError: false,
						entityRelationDataFetchCount: 0,
						requestedEntityRelationData: action.edgeData,
					},
				},
			};
		}

		case Actions.AGENT_RECEIVE_ENTITY_RELATION_DATA: {
			return {
				...state,
				agentData: {
					...state.agentData,
					bio: {
						...state.agentData.bio,
						entityRelationData: action.data,
						entityRelationDataLoading: false,
						entityRelationDataError: false,
						entityRelationDataFetchCount: 0,
					},
				},
			};
		}

		case Actions.AGENT_RECEIVE_ENTITY_RELATION_DATA_ERROR: {
			return {
				...state,
				agentData: {
					...state.agentData,
					bio: {
						...state.agentData.bio,
						entityRelationData: null,
						entityRelationDataLoading: false,
						entityRelationDataError: true,
						entityRelationDataFetchCount: 0,
					},
				},
			};
		}

		case Actions.AGENT_RECEIVE_ENTITY_RELATION_DATA_RETRY: {
			return {
				...state,
				agentData: {
					...state.agentData,
					bio: {
						...state.agentData.bio,
						entityRelationDataFetchCount: state.agentData.bio.entityRelationDataFetchCount + 1,
					},
				},
			};
		}

		case Actions.AGENT_FETCH_GRAPH_DATA: {
			return {
				...state,
				agentData: {
					...state.agentData,
					bio: {
						...state.agentData.bio,
						graphDataLoading: true,
						graphDataError: false,
						graphDataFetchCount: 0,
						graphNumUpdates: 0,
						graphNodesAdded: 0,
						graphEdgesAdded: 0,
						graphNodesRemoved: 0,
						graphEdgesRemoved: 0,
					},
				},
			};
		}

		case Actions.AGENT_RECEIVE_GRAPH_DATA: {
			return {
				...state,
				agentData: {
					...state.agentData,
					bio: {
						...state.agentData.bio,
						graphData: action.data,
						graphEdgeMap: action.edgeMap,
						graphNodeMap: action.nodeMap,
						graphDataLoading: false,
						graphDataError: false,
						graphDataFetchCount: 0,
						graphNumUpdates: state.agentData.bio.graphNumUpdates + 1,
						graphNodesAdded: action.data.nodes.length || 0,
						graphEdgesAdded: action.data.edges.length || 0,
						graphNodesRemoved: 0,
						graphEdgesRemoved: 0,
					},
				},
			};
		}

		case Actions.AGENT_RECEIVE_GRAPH_DATA_ERROR: {
			return {
				...state,
				agentData: {
					...state.agentData,
					bio: {
						...state.agentData.bio,
						graphData: null,
						graphEdgeMap: {},
						graphNodeMap: {},
						graphDataLoading: false,
						graphDataError: true,
						graphDataFetchCount: 0,
					},
				},
			};
		}

		case Actions.AGENT_RECEIVE_GRAPH_DATA_RETRY: {
			return {
				...state,
				agentData: {
					...state.agentData,
					bio: {
						...state.agentData.bio,
						graphDataFetchCount: state.agentData.bio.graphDataFetchCount + 1,
					},
				},
			};
		}

		case Actions.AGENT_FETCH_EXPAND_GRAPH_DATA: {
			return {
				...state,
				agentData: {
					...state.agentData,
					bio: {
						...state.agentData.bio,
						graphExpanding: true,
						graphExpandError: false,
						graphExpandFetchCount: 0,
					},
				},
			};
		}

		case Actions.AGENT_RECEIVE_EXPAND_GRAPH_DATA: {
			return {
				...state,
				agentData: {
					...state.agentData,
					bio: {
						...state.agentData.bio,
						graphData: action.isChanged ? action.data : state.agentData.bio.graphData,
						graphEdgeMap: action.isChanged ? action.edgeMap : state.agentData.bio.graphEdgeMap,
						graphNodeMap: action.isChanged ? action.nodeMap : state.agentData.bio.graphNodeMap,
						graphExpanding: false,
						graphExpandError: false,
						graphExpandFetchCount: 0,
						graphNodesAdded: action.numNodesAdded,
						graphEdgesAdded: action.numEdgesAdded,
						graphNodesRemoved: 0,
						graphEdgesRemoved: 0,
						graphNumUpdates:
							action.numNodesAdded || action.numEdgesAdded
								? state.agentData.bio.graphNumUpdates
								: state.agentData.bio.graphNumUpdates + 1,
					},
				},
			};
		}

		case Actions.AGENT_RECEIVE_EXPAND_GRAPH_DATA_ERROR: {
			return {
				...state,
				agentData: {
					...state.agentData,
					bio: {
						...state.agentData.bio,
						graphExpanding: false,
						graphExpandError: true,
						graphExpandFetchCount: 0,
					},
				},
			};
		}

		case Actions.AGENT_RECEIVE_EXPAND_GRAPH_DATA_RETRY: {
			return {
				...state,
				agentData: {
					...state.agentData,
					bio: {
						...state.agentData.bio,
						graphExpandFetchCount: state.agentData.bio.graphExpandFetchCount + 1,
					},
				},
			};
		}

		case Actions.AGENT_SET_GRAPH_DEPTH: {
			return {
				...state,
				agentData: {
					...state.agentData,
					bio: {
						...state.agentData.bio,
						graphDepth: action.depth,
					},
				},
			};
		}

		case Actions.AGENT_SET_GRAPH_EXPAND_DEPTH: {
			return {
				...state,
				agentData: {
					...state.agentData,
					bio: {
						...state.agentData.bio,
						graphExpandDepth: action.depth,
					},
				},
			};
		}

		case Actions.AGENT_SET_GRAPH_SETTINGS_EXPANDED: {
			return {
				...state,
				agentData: {
					...state.agentData,
					bio: {
						...state.agentData.bio,
						graphSettingsExpanded: action.expanded,
					},
				},
			};
		}

		case Actions.AGENT_SET_GRAPH_FILTERS_EXPANDED: {
			return {
				...state,
				agentData: {
					...state.agentData,
					bio: {
						...state.agentData.bio,
						graphFiltersExpanded: action.expanded,
					},
				},
			};
		}

		case Actions.AGENT_SET_AFFILIATIONS_WIDGET_EXPANDED: {
			return {
				...state,
				agentData: {
					...state.agentData,
					bio: {
						...state.agentData.bio,
						affiliationsExpanded: action.expanded,
					},
				},
			};
		}

		case Actions.AGENT_SET_ENTITIES_WIDGET_EXPANDED: {
			return {
				...state,
				agentData: {
					...state.agentData,
					bio: {
						...state.agentData.bio,
						entitiesExpanded: action.expanded,
					},
				},
			};
		}

		case Actions.AGENT_SET_ENTITIES_SORT: {
			return {
				...state,
				agentData: {
					...state.agentData,
					bio: {
						...state.agentData.bio,
						entitiesSortType: action.sortType,
						entitiesSortAscending: action.sortAscending,
					},
				},
			};
		}

		case Actions.AGENT_SET_ENTITIES_CURSOR_POS: {
			return {
				...state,
				agentData: {
					...state.agentData,
					bio: {
						...state.agentData.bio,
						entitiesCursorPosition: action.pos,
						entitiesPageOffset: action.offset,
					},
				},
			};
		}

		case Actions.AGENT_SET_EXPORT_OPTIONS: {
			return {
				...state,
				agentData: {
					...state.agentData,
					bio: {
						...state.agentData.bio,
						exportOptions: action.options,
					},
				},
			};
		}

		case Actions.AGENT_SET_SHOW_GRAPH_LABELS: {
			return {
				...state,
				agentData: {
					...state.agentData,
					bio: {
						...state.agentData.bio,
						showGraphLabels: action.show,
					},
				},
			};
		}

		case Actions.AGENT_SET_SHOW_GRAPH_EDGE_LABELS: {
			return {
				...state,
				agentData: {
					...state.agentData,
					bio: {
						...state.agentData.bio,
						showGraphEdgeLabels: action.show,
					},
				},
			};
		}

		case Actions.AGENT_SET_GRAPH_LAYOUT_RUNNING: {
			return {
				...state,
				agentData: {
					...state.agentData,
					bio: {
						...state.agentData.bio,
						graphLayoutRunning: action.running,
					},
				},
			};
		}

		case Actions.AGENT_RESET_ALL_CURSOR_POS: {
			return {
				...state,
				agentData: {
					...state.agentData,
					bio: {
						...state.agentData.bio,
						entitiesCursorPosition: 1,
						entitiesPageOffset: 0,
					},
				},
			};
		}

		case "SET_ERROR_STATE":
			return {
				...state,
				errorState: {
					throwError: action.throwError,
				},
			};

		default:
			return state;
	}
};

export default agentReducer;
